<template lang="pug">
.registration-form
	h2#registration-form-title.sf-heading-1 Ingyenes regisztráció
	p.sf-text Regisztrálj az eBIZ-be mindössze néhány perc alatt!
		br
		| Első lépésként add meg az e-mail-címedet!
	form(@submit.prevent="send")
		.form-row(:class="{ 'has-error': $v.model.email.$dirty && $v.model.email.$invalid }")
			.form-col
				VueInput#registration-email-input(label="Email címed", v-model="model.email", :max-width="352", :max-length="50", :has-error="$v.model.email.$dirty && $v.model.email.$invalid", @blur="$v.model.email.$touch()", aria-describedby="registration-error")
				VueErrorMessage#registration-error(v-if="$v.model.email.$dirty && !$v.model.email.required", position="bottom") Kérjük, adja meg e-mail címét!
				VueErrorMessage#registration-error(v-if="$v.model.email.$dirty && !$v.model.email.email", position="bottom") Kérjük, ellenőrizze az e-mail címet!
		.form-row(v-if="captcha.htmlFragment")
			.form-col
				VueCaptcha#captcha-input(label="Captcha", @input="resetCapthcaError", :img="'data:image/png;base64,' + captcha.htmlFragment", v-model="model.captchaText", :max-width="104", :max-length="5", @blur="$v.model.captchaText.$touch()", :has-error="($v.model.captchaText.$dirty && !$v.model.captchaText.required) || captchaError", aria-describedby="captcha-error")
				VueErrorMessage#captcha-error(v-if="$v.model.captchaText.$dirty && !$v.model.captchaText.required && !captchaError", position="bottom") Kérjük, adja meg a képen látható kódot!
				VueErrorMessage#captcha-error(v-if="captchaError", position="bottom") Kérjük, ellenőrizze a képen látható kódot!
		.form-row
			VueButton(type="submit", :disabled="sending", aria-labelledby="registration-form-title") Tovább
</template>
<script>
import VueErrorMessage from '@ui-common/vue-error-message';
import VueFeedback from '@ui-common/vue-feedback';
import VueInput from '@ui-common/vue-input';
import VueCaptcha from '@ui-common/vue-captcha';
import { required } from 'vuelidate/lib/validators';
import email from '../../../common/js/validators/email';
import { jumpToFirstError } from '../../../common/js/find-first-error-component/find-first-error-component';
import captchaApi from '../../../api/captcha-api';
import registrationApi from '../../../api/registration-api';

export default {
	props: {
		indexUrl: {
			required: true
		}
	},
	mixins: [jumpToFirstError],
	components: {
		VueErrorMessage,
		VueFeedback,
		VueInput,
		VueCaptcha
	},
	data: () => ({
		sending: false,
		captcha: null,
		captchaError: false,
		model: {
			email: null,
			captchaText: null,
			captchaKey: null
		}
	}),
	methods: {
		async getCaptcha() {
			try {
				const response = await captchaApi.getCaptcha();
				this.captcha = response.data;
				this.model.captchaKey = response.data.captchaKey;
			} catch (err) {
				this.$emit('error');
			}
		},
		async send() {
			this.$v.$touch();
			if (this.$v.$invalid || this.captchaError) {
				this.jumpToFirstError();
			} else {
				try {
					const sentModel = { ...this.model };
					if (!this.captcha.htmlFragment) {
						delete sentModel.captchaKey;
					}
					this.sending = true;
					await registrationApi.sendRegistration(sentModel);
					this.$emit('success', this.model.email);
				} catch (err) {
					if (err?.response?.status == 400 && err?.response?.data?.captchaText) {
						this.getCaptcha();
						this.captchaError = true;
					} else {
						this.$emit('error');
					}
				} finally {
					this.sending = false;
				}
			}
		},
		resetCapthcaError() {
			if (this.captchaError) {
				this.captchaError = false;
			}
		}
	},
	validations() {
		return {
			model: {
				captchaText: this.captcha?.htmlFragment
					? {
							required
					  }
					: {},
				email: {
					required,
					email
				}
			}
		};
	},
	created() {
		this.getCaptcha();
	}
};
</script>
<style lang="scss">
@import '~@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.registration-form {
	padding: 0 24px;

	@include media('>=tablet') {
		padding: 0 48px;
	}

	@include media('>=desktop') {
		padding: 0 96px;
	}
}

.registration-form .sf-heading-1 {
	margin-bottom: 8px;
}

.registration-form .sf-text {
	margin-bottom: 32px;
}

.registration-form .form-row {
	padding-left: 0;
	padding-right: 0;
}

.registration-form .form-row:not(:last-child) {
	margin-bottom: 48px;
}

.registration-form .form-row .sf-btn:first-of-type {
	margin-right: 24px;
}
</style>
